import getFromCdn from '@anm/helpers/getFromCdn';

import { MappedDestinationItems } from '../AccountList';

const getWebinarDestination = (props: Record<string, any> = {}): MappedDestinationItems =>
  ({
    avatar: getFromCdn('images/icons/webinar-destination.svg'),
    id: 'webinar',
    kind: null,
    title: 'Webinar',
    network: 'WEBINAR',
    user_id: '',
    ...props
  } as MappedDestinationItems);

export default getWebinarDestination;
